import { Navigate } from 'react-router-dom'

/** Legacy route — patron screening keys live under Patron Screening Settings. */
export default function ScreeningApiKeys() {
  return <Navigate to="/compliance-safe/settings/patron-screening?tab=keys" replace />
}
